export default __webpack_public_path__ + "static/media/product_sponsors_2.44706260.png";